import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Actions from './actions';
import * as Api from './api';
import * as Constants from './constants';

const fetchObservable = (
    institutionId,
    from,
    splitAt,
    groupBy,
    showChildLeaveAsAvailable,
    successAction,
    failAction,
) => {
    // If the full-day option is chosen we don't send the `splitAt` query param.
    // This will prevent the backend from splitting up the days into two time buckets.
    const split = splitAt === Constants.FULL_DAY_OPTION_VALUE ? null : splitAt;

    return Api.fetchReport(institutionId, from, split, groupBy, showChildLeaveAsAvailable)
        .map(response => successAction(response))
        .catch(e => Observable.of(failAction(e)));
};

const fetch = action$ =>
    action$
        .ofType(Actions.fetch.type)
        .mergeMap(({payload}) =>
            fetchObservable(
                payload.institutionId,
                payload.from,
                payload.splitAt,
                payload.groupBy,
                payload.showChildLeaveAsAvailable,
                Actions.fetchSuccess.action,
                Actions.fetchFailed.action,
            ),
        );

const resetAndFetch = action$ =>
    action$
        .ofType(Actions.resetAndFetch.type)
        .mergeMap(({payload}) =>
            fetchObservable(
                payload.institutionId,
                payload.from,
                payload.splitAt,
                payload.groupBy,
                payload.showChildLeaveAsAvailable,
                Actions.resetAndFetchSuccess.action,
                Actions.resetAndFetchFailed.action,
            ),
        );

export default combineEpics(fetch, resetAndFetch);
